import React from "react";

import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Block from "../../block/Block";
import Input from "../../form/Input";
import Select from "../../form/Select";

import type { JSX } from "react";
import type { StylesConfig } from "react-select";

interface Props {
  isDefaultSchedule: boolean;
  uuid: string;
}

interface ScheduleOption {
  value: string;
  label: string;
  logoUrl: string;
}

export default function ScheduleSettings({
  isDefaultSchedule,
  uuid,
}: Props): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");
  const [scheduleName, broadcastSelectList] = useWatch({
    name: [`${uuid}.name`, `${uuid}.broadcastSelectList`],
  });

  const broadcastSelectListOptions = broadcastSelectList
    ? [...broadcastSelectList]
    : [];

  const selectBroadcastsStyles: StylesConfig<ScheduleOption, true> = {
    multiValue: (styles, { data }) => ({
      ...styles,
      alignItems: "center",

      ":before": {
        content: '" "',
        display: "inline-block",
        width: 30,
        height: 30,
        margin: "2px 0 1px",
        borderRadius: "0.375rem",
        alignSelf: "center",
        background: `center / contain no-repeat url(${data.logoUrl})`,
      },
    }),
  };

  return (
    <Block
      isCollapsedByDefault
      isCollapsable={!isDefaultSchedule}
      title={t("scheduleSettingsTitle", { scheduleName })}
    >
      <Input isRequired label={t("name")} name={`${uuid}.name`} />
      <Input
        isFullWidth
        isRequired
        label={t("associatedColor")}
        name={`${uuid}.color`}
        type="color"
      />
      <Select
        isMulti
        isReadOnly
        withoutBorder
        label={t("associatedDestinations")}
        name={`${uuid}.broadcastSelectList`}
        options={broadcastSelectListOptions}
        placeholder={t("noBroadcasts")}
        styles={selectBroadcastsStyles}
      />
      <Input
        isRequired
        label={t("programObjectivesPerDays")}
        name={`${uuid}.daily_programs_objective`}
        type="number"
      />
      <Input
        isRequired
        label={t("adsObjectivesPerDays")}
        name={`${uuid}.daily_ads_objective`}
        type="number"
      />
    </Block>
  );
}
